export type LegIndex = typeof OUTBOUND_LEG_INDEX | typeof RETURN_LEG_INDEX;
export const OUTBOUND_LEG_INDEX = 0 as const;
export const RETURN_LEG_INDEX = 1 as const;
